import {
    CREATE_CAMPAIGN_END,
    CREATE_CAMPAIGN_START,
    CREATE_CAMPAIGN_DATE,
    GET_CAMPAIGN_FIELD,
} from '../slices/type';

interface InitState {
    data: any[]; 
    getField: any[]; 
    dataSingle: any[]; 
    loading: boolean;
}

const initState: InitState = {
    data: [],
    dataSingle: [],
    getField:[],
    loading: false,
};

interface Action {
    type: string;
    payload?: any; 
    loading?: boolean;
}

const createCampaign_Red = (state = initState, action: Action): InitState => {
    switch (action.type) {
        case CREATE_CAMPAIGN_START:
            return {
                ...state,
                loading: action.loading ?? false, 
            };
        case CREATE_CAMPAIGN_DATE:
            return {
                ...state,
                data: action.payload ?? [],
                loading: action.loading ?? false,
            };
            case GET_CAMPAIGN_FIELD:
            return {
                ...state,
                getField: action.payload ?? [],
                loading: action.loading ?? false,
            };
        case CREATE_CAMPAIGN_END:
            return {
                ...state,
                dataSingle: action.payload ?? [],
                loading: action.loading ?? false,
            };
        default:
            return state;
    }
};

export default createCampaign_Red;
